export const buildNativeAppointmentGoogleEventIds = (
  appointments: readonly { calendarEventId: string | null }[] | undefined,
): ReadonlySet<string> => {
  const ids = new Set<string>();
  if (!appointments) return ids;
  for (const appointment of appointments) {
    if (appointment.calendarEventId) ids.add(appointment.calendarEventId);
  }
  return ids;
};
